import Component from '@glimmer/component'
import { service } from '@ember/service'
import t from 'ember-intl/helpers/t'
import formatDate from 'ember-intl/helpers/format-date'
import type IntlService from 'ember-intl/services/intl'
import Icon from 'customer-flows/components/ui-kit/icon'
import ReviewSummary from 'customer-flows/components/booking/review-summary'
import ReviewComment from 'customer-flows/components/booking/review-comment'

export interface ReviewCardsSignature {
  Element: HTMLDivElement
  Args: {
    reviews: Review[]
    count: number
    avgRating?: number
  }
}

export default class ReviewCards extends Component<ReviewCardsSignature> {
  @service intl: IntlService

  get stars(): string {
    return this.intl.t('booking.reviews.star-symbol').repeat(5)
  }

  <template>
    {{#if @reviews.length}}
      <hr class='border-neutrals-100 my-6 border-0 border-b' data-testid='review-cards__divider' />

      <div class='flex flex-col gap-3' data-testid='review-cards'>
        <div class='flex flex-wrap items-center gap-2'>
          <h2 class='text-xbold-header-20 text-neutrals-350'>{{t 'booking.reviews.section-header'}}</h2>

          <il-tooltip tooltip-position='top' tooltip-text={{t 'booking.reviews.tooltip'}} data-testid='review-cards__tooltip'>
            <Icon @src='info' class='h-5 w-5 text-neutrals-300' />
          </il-tooltip>

          <div class='ml-auto'>
            <ReviewSummary @count={{@count}} @avgRating={{@avgRating}} />
          </div>
        </div>

        {{#each @reviews as |review|}}
          <il-section data-testid='review-card' class='il-section:rounded-3'>
            <div slot='content' class='flex flex-col gap-2'>
              <ReviewComment @text={{review.comment}} />
              <div class='text-bold-para-14 text-neutrals-300 flex items-center gap-2'>
                <span data-testid='review-card__name'>{{review.name}}</span>
                <span class='bg-neutrals-200 h-4 w-0.5' aria-hidden='true'></span>
                <span data-testid='review-card__date'>{{formatDate review.reviewedAt month='long' year='numeric'}}</span>
              </div>
              <div class='flex items-center gap-2 text-component-bold-para-16 text-neutrals-350' aria-hidden='true'>
                <span>{{t 'booking.reviews.rating-value'}}</span>
                <span class='tracking-[0.15em] text-[hsla(45,100%,51%,1)]'>{{this.stars}}</span>
              </div>
            </div>
          </il-section>
        {{/each}}
      </div>
    {{/if}}
  </template>
}
